"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Caesar = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const PlaceHazardTile_1 = require("../../deferredActions/PlaceHazardTile");
const Size_1 = require("../render/Size");
const SelectProductionToLoseDeferred_1 = require("../../deferredActions/SelectProductionToLoseDeferred");
const TileType_1 = require("../../TileType");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class Caesar extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.CAESAR,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L33',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().colon().text('X').hazardTile(1, { size: Size_1.Size.LARGE }).nbsp();
                    b.minus().production((pb) => pb.wild(1).any).asterix();
                    b.br;
                }),
                description: 'Once per game, place X hazard tiles equal to the current generation number. Each opponent loses units of production equal to half the number of hazard tiles in play, rounded up.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const game = player.game;
        return this.isDisabled === false && game.board.getAvailableSpacesOnLand(player).length >= game.generation;
    }
    action(player) {
        const game = player.game;
        const title = 'Select space for hazard tile';
        for (let i = 0; i < game.generation; i++) {
            const availableSpaces = game.board.getAvailableSpacesOnLand(player);
            game.defer(new PlaceHazardTile_1.PlaceHazardTile(player, game, title, availableSpaces));
        }
        const otherPlayers = game.getPlayers().filter((p) => p.id !== player.id);
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            const hazardTileCount = game.board.spaces.filter((space) => space.tile && TileType_1.HAZARD_TILES.has(space.tile.tileType)).length;
            otherPlayers.forEach((player) => {
                game.defer(new SelectProductionToLoseDeferred_1.SelectProductionToLoseDeferred(player, Math.ceil(hazardTileCount / 2)));
            });
            return undefined;
        }));
        this.isDisabled = true;
        return undefined;
    }
}
exports.Caesar = Caesar;
//# sourceMappingURL=Caesar.js.map